import BaseGenericEvent from '../../BaseGenericEvent';
import { getBookingDetails, getSearchEventData } from "../../PdtHelper/RailsPdtUtils";
import {RailsPdtConstants} from '../../PdtHelper/RailsPdtConstants';

export default class RailsPdtThankYouEvent extends BaseGenericEvent {
  constructor(pdtData) {
    const data = pdtData;
    data.pageName = RailsPdtConstants.FunnelStep.THANKYOU;
    data.funnelStep = RailsPdtConstants.FunnelStep.THANKYOU;
    super(data);
    this.bookingData = pdtData.bookingData;
    this.searchContextData = pdtData.searchContextData;
  }

  trackThankYouEvent = () => {
    const basePdtObject = this.basePdtData();
    basePdtObject.booking_details = getBookingDetails(this.bookingData);
    basePdtObject.rail_search_context = getSearchEventData(this.searchContextData);
    return basePdtObject;
  }
}
